import React from 'react'
import styled from '@emotion/styled'
import { connect } from 'react-redux'
import { Locale, Translation } from 'locale'
import { TradingTypeHelper, CollateralBasketTypeHelper } from 'model'
import { formatBoolean } from 'locale/Locale'
import { CollateralBasketDetail, UserPreference } from 'api'
import { createStructuredSelector } from 'reselect'
import { createUserPreferenceSelector } from 'selectors/userPreferenceSelectors'

interface ReadOnlyCollateralOverviewPanelProps {
  collateralBasketDetail: Pick<CollateralBasketDetail, 'collateralBasket' | 'productSector'>
  userPreference: UserPreference
}

export const mapStateToProps = createStructuredSelector({
  userPreference: createUserPreferenceSelector()
})

const DescriptionList = styled.dl`
  display: grid;
  grid-template-columns: max-content auto;
  grid-column-gap: 30px;
  grid-row-gap: 5px;

  dt {
    grid-column-start: 1;
    font-weight: bold;
  }

  dd {
    grid-column-start: 2;
  }
`

const ReadOnlyCollateralOverviewPanelComponent: React.FunctionComponent<ReadOnlyCollateralOverviewPanelProps> = ({
  collateralBasketDetail: { collateralBasket, productSector },
  userPreference
}) => {
  return (
    <DescriptionList>
      <dt>{Locale.translate(Translation.TC_BASKET_NAME)}</dt>
      <dd>{collateralBasket.name}</dd>

      <dt>{Locale.translate(Translation.TC_BASKET_DESCRIPTION)}</dt>
      <dd>{collateralBasket.description}</dd>

      <dt>{Locale.translate(Translation.TC_BASKET_OWNER)}</dt>
      <dd>{collateralBasket.collateralBasketOwner}</dd>

      <dt>{Locale.translate(Translation.TC_BASKET_TYPE)}</dt>
      <dd>{productSector?.basketType && CollateralBasketTypeHelper.getName(productSector.basketType)}</dd>

      <dt>{Locale.translate(Translation.TC_TRADING_TYPE)}</dt>
      <dd>{TradingTypeHelper.getName(collateralBasket.tradingType)}</dd>

      <dt>{Locale.translate(Translation.TC_CURRENCY)}</dt>
      <dd>{productSector?.basketCurrency}</dd>

      <dt>{Locale.translate(Translation.TC_MINIMUM_CONCENTRATION_LEVEL)}</dt>
      <dd>{Locale.formatNumber(collateralBasket.minConcentration, { decimalShift: 2, percent: true })}</dd>

      <dt>{Locale.translate(Translation.TC_MAXIMUM_CONCENTRATION_LEVEL)}</dt>
      <dd>{Locale.formatNumber(collateralBasket.maxConcentration, { decimalShift: 2, percent: true })}</dd>

      <dt>{Locale.translate(Translation.TC_MINIMUM_AMOUNT)}</dt>
      <dd>{collateralBasket.minAmount}</dd>

      <dt>{Locale.translate(Translation.TC_SUBSTITUTION_ALLOWED)}</dt>
      <dd>{formatBoolean(!!collateralBasket.substitutionAllowed)}</dd>

      <dt>{Locale.translate(Translation.TC_SUBSTITUTION_NUM)}</dt>
      <dd>{collateralBasket.substitutionsNum}</dd>

      <dt>{Locale.translate(Translation.TC_CALCULATE_ACCRUED_INTEREST)}</dt>
      <dd>{formatBoolean(!!collateralBasket.calculateAccruedInterest)}</dd>

      <dt>{Locale.translate(Translation.TC_FROM_DATE)}</dt>
      <dd>{Locale.formatDate(collateralBasket.basketFromDate, userPreference.dateFormat)}</dd>

      <dt>{Locale.translate(Translation.TC_TO_DATE)}</dt>
      <dd>{Locale.formatDate(collateralBasket.basketToDate, userPreference.dateFormat)}</dd>
    </DescriptionList>
  )
}

export const ReadOnlyCollateralOverviewPanel = connect(mapStateToProps)(ReadOnlyCollateralOverviewPanelComponent)
